import PropTypes from 'prop-types';
import React from 'react';

import Arquivo from '../arquivo/Arquivo.react.js';

export const IntencaoRegistroPrecoAnexos = ({ arquivos, onDownload }) => (
  <Arquivo
    arquivos={arquivos}
    onDownload={onDownload}
    emptyText="Não há anexos para esta IRP."
    sortByDate="DESC"
  >
    <Arquivo.Coluna
      id="tipoArquivo"
      titulo="Tipo do Arquivo"
      valor={arquivo => arquivo.get('tipoArquivo')}
    />
  </Arquivo>
);

IntencaoRegistroPrecoAnexos.propTypes = {
  arquivos: PropTypes.object.isRequired,
  onDownload: PropTypes.func.isRequired
};

export default IntencaoRegistroPrecoAnexos;
